import { DateType } from 'ui/datePicker';

export type DateRange = {
  startDate: DateType;
  endDate: DateType;
};

export enum TimePreset {
  TODAY = 'TODAY',
  PAST_3_DAYS = 'PAST_3_DAYS',
  PAST_7_DAYS = 'PAST_7_DAYS',
  PAST_30_DAYS = 'PAST_30_DAYS',
  CUSTOM_RANGE = 'CUSTOM_RANGE',
  EXPERIMENT_PERIOD = 'EXPERIMENT_PERIOD',
  EXPERIMENT_START_TO_NOW = 'EXPERIMENT_START_TO_NOW',
}

type TimePresetContext = {
  menuLabel: string;
  filterLabel: string;
  format: (timezone: string) => DateRange;
};

type CustomTimePresetContext = Omit<TimePresetContext, 'format'>;

export type Presets = {
  [k in Exclude<TimePreset, TimePreset.CUSTOM_RANGE>]?: TimePresetContext;
} & {
  [TimePreset.CUSTOM_RANGE]: CustomTimePresetContext;
};
